<div id="assessment-header">
  <nav class="navbar navbar-expand" style="margin-bottom: 0px" role="presentation">
    <div class="container-fluid flex-column flex-sm-row px-md-4">
      <div class="left-header-items">
        <div class="navbar-nav mr-auto top-2 left-header-wrapper">
          <button
            app-button
            appTooltip="Go Back"
            type="button"
            class="cursor-pointer btn btn-icon btn-secondary back-btn"
            (click)="cancel($event)"
            (keydown.enter)="cancel($event)"
            (keydown.space)="cancel($event)"
            [ngClass]="show ? 'back-btn-up' : 'back-btn-down'"
            tabindex="0"
            role="button"
            (click)="cancel($event)"
            (keydown.enter)="cancel($event)"
            (keydown.space)="cancel($event)"
            aria-label="Cancel"
          >
            <i
              class="dpg-icon dpg-icon-dropdown-arrow-left"
              aria-hidden="true"
            ></i>
          </button>
          <div
            (click)="showHideTitle(true)"
            [ngClass]="show ? 'rename-up' : 'rename-down'"
          >
            <label class="title-head" id="renameHeader" for="testTitle">
              Title:
              <app-required-indicator [required]="true" [ariaHidden]="true"></app-required-indicator>
            </label>
          </div>
          <div class="assessment-title">
            <app-input
              [id]="'testTitle'"
              [error]="false"
              [placeholder]="inputPlaceholder"
              [(ngModel)]="headerName"
              [type]="inputType.Text"
              (ngModelChange)="modelChanged($event)"
              [maxlength]="80"
              (focusout)="showHideTitle(false)"
              [required]="true"
            ></app-input>
          </div>
        </div>
      </div>
      <div class="row head-alert">
        <div class="col-md-12 col-lg-12 p-0">
          <app-alert
            [type]="alertType.Success"
            [suppressAnnouncement]="suppressAnnouncement"
            (close)="closeAlertModal()"
            *ngIf="showSuccessAlert"
          >
            {{ alertSuccessMessage }}
          </app-alert>
        </div>
      </div>
      <div class="right-header-items pr-lg-2">
        <ul class="navbar-nav ml-0 ml-sm-3 mr-auto">
          <li class="nav-item">
            <strong>Total Questions: </strong> {{ headerData.totalQuestions }}
          </li>
          <li class="nav-item active">
            <strong>Total Points: </strong>{{ headerData.totalPoints }}
          </li>
          <li *ngIf="headerData.previewButton != ''" class="nav-item">
            <div class="previewTitle">
              <span class="preview-text-color">{{
                headerData.previewButton
              }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<div class="sr-only" aria-live="polite">
  {{ stepperAnnouncementMessage }}
</div>
<common-modal-component
  *ngIf="showConfirmationHeader"
  [size]="size"
  [header]="modalHeader"
  [isScrollableFocus]="true"
  (modalOk)="modalOkJob()"
  (modalCancel)="modalCancelJob()"
>
  {{ alertMessage }}
</common-modal-component>

<!-- #make-edit-copy modal start -->
<ng-template cdkPortal #editorAlertTemplatePortal>
  <div
    #editorShowModal
    class="ahe-ui-alert-modal"
    id="editorShowModal"
    tabindex="-1"
  >
    <div class="modal-overlay">
      <div class="modal-container-new">
        <div
          class="modal-dialog-more-info-new"
        >
          <div class="modal-content" role="alert">
            <div class="modal-header-new"><h2 id="alertModalTitle" class="modal-title">Alert</h2></div>
            <div class="modal-body-new">
              <div class="editor-msg">{{ editorLoaderMessage }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- #make-edit-copy modal start  -->
